export default {
  login: {
    ATTEMPT: 'Attempt',
    ATTEMPTS: 'Attempts',
    CURRENT: 'Current',
    EMAIL: 'Email',
    FAILED: 'Failed',
    FORGOT_PASSWORD: 'Forgot password?',
    FORGOT_PASSWORD_TEXT: 'We will send you an email for you to reset your password:',
    LOGIN: 'Login',
    NOT_ACTIVE_USER: 'User is not active',
    NOT_VALID_EMAIL: 'Email not valid',
    NOT_VALID_CREDENTIAL: 'Username or password not valid',
    PASSWORD: 'Password',
    PASSWORD_IS_REQUIRED: 'Password is required',
    REGION_1: 'Region 1',
    REGION_2: 'Region 2',
    REMAINING: 'Remaining',
    SEND: 'Send',
    SEND_FORGOT_PASSWORD: 'Please check your email inbox',
    USER_LOCKOUT_COUNTDOWN: 'Authentication is blocked for $countdown due to $failedAttempts failed attempts.',
    USERNAME: 'Username',
    USERNAME_IS_REQUIRED: 'Username is required',
  },
};
